import React from 'react';
import './InputBar.css';
import { useTranslation } from 'react-i18next';

function InputBar({ currentInput, onGuess, onHint, guessStatus, canAffordHint }) {
  const { t } = useTranslation();

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onGuess();
    }
  };

  return (
    <div className="input-area">
      <div className={`input-bar-container ${guessStatus === 'failure' ? 'shake' : ''}`}>
        <div className="hint-button-container">
          <button
            className="hint-button"
            onClick={onHint}
            disabled={!canAffordHint}
            aria-label={t('hint')}
          >
            {/* --- MUDANÇA: Corrigido o viewBox para "0 0 24 24" --- */}
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2a7 7 0 0 0-7 7c0 3.03 1.53 5.63 3.79 6.94.13.07.21.21.21.36v1.2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.2c0-.15.08-.29.21-.36A6.97 6.97 0 0 0 19 9a7 7 0 0 0-7-7z"></path>
              <path d="M12 20h0"></path>
            </svg>
          </button>
          {canAffordHint && <div className="hint-cost-badge">15 💰</div>}
        </div>

        <div className="input-display" onKeyPress={handleKeyPress}>
          {currentInput}
        </div>

        <button
          className="submit-button"
          onClick={onGuess}
          aria-label={t('submit_guess')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M12 19V5"></path><path d="m5 12 7-7 7 7"></path></svg>
        </button>
      </div>
    </div>
  );
}

export default InputBar;